module.exports = __webpack_public_path__ + "media/anmoukeji.ebe9a54d.mp4";